import ProductCategorySpotlight from '@/_application/pages/home/components/product-category-spotlight/product-category-spotlight.desktop';
import {HomepageFeaturedBlock, HighlightBrands} from '__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';

export interface HomepageFeaturedBlockWithProducts extends HomepageFeaturedBlock {
    fetchedProducts?: Product[];
    fetchedHighlightProduct?: Product | null;
}

export interface ProductCategorySpotlightListProps {
    homepageFeaturedBlocks?: HomepageFeaturedBlockWithProducts[];
    highlightBrands?: HighlightBrands | null;
}

const ProductCategorySpotlightList = ({
    homepageFeaturedBlocks = [],
    highlightBrands,
}: ProductCategorySpotlightListProps) => {
    if (homepageFeaturedBlocks.length === 0) {
        return null;
    }

    return (
        <div className="flex min-h-[54.313rem] w-full flex-col items-center justify-center bg-secondary">
            <div className="w-[698px] py-5 lg:w-[950px] xl:w-[1196px]">
                <div className="flex flex-col gap-5">
                    {homepageFeaturedBlocks.map(block => (
                        <ProductCategorySpotlight key={block?.name} data={block} highlightBrands={highlightBrands} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductCategorySpotlightList;
